const NEWBEC_DEVICE_TYPE_MAP: TStringObject = {
  phone: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
};

/**
 * @deprecated
 * Нужно перейти на getAnalyticsSiteType, затем заменить его селектором
 */
export function getClientDeviceType() {
  if (typeof window !== 'undefined' && window.addformDeviceType) {
    return NEWBEC_DEVICE_TYPE_MAP[window.addformDeviceType];
  }

  return 'desktop';
}
